"use client";

import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Image from "next/image";
import ui6 from "@/assest/ui6.png";
import { IHeroRecord } from "../interface/IHeroSection";
import RichText from "@/utils/richText";

const PackageHero = ({ breadcrumbData }: { breadcrumbData: IHeroRecord[] }) => {
  const [index] = useState(0);
  const sliderImages = breadcrumbData?.[0]?.image || [];
  const currentItem = breadcrumbData?.[0];

  return (
    <div className="relative w-full mb-12 h-[60vh]">
      <figure className="absolute inset-0 w-full h-full overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 1.1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8 }}
            className="absolute inset-0"
          >
            <Image
              src={sliderImages[index]?.image}
              alt="Hero Background"
              fill
              priority
              className="object-cover brightness-[0.55]"
            />
          </motion.div>
        </AnimatePresence>

        <div className="absolute inset-0 bg-black/40" />
      </figure>

      <div className="relative z-10 h-full max-w-7xl mx-auto px-6 flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="w-full max-w-4xl flex flex-col items-center justify-center text-center text-white"
        >
          <h1 className="font-black text-4xl md:text-6xl lg:text-7xl mb-4 uppercase leading-tight">
            {currentItem?.title}
          </h1>

          <div className="max-w-2xl mx-auto">
            <RichText
              content={currentItem?.subtitle || ""}
              className="text-gray-100 text-lg md:text-xl line-clamp-4 leading-relaxed font-medium"
            />
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-20 hidden md:block">
        <Image
          src={ui6}
          alt="decoration"
          width={60}
          height={60}
          className="animate-bounce"
        />
      </div>
    </div>
  );
};

export default PackageHero;
